import { memo } from 'react';

import { Button, PageTitle } from '@dec/shared';
import { ButtonAction } from '@dec/shared';
import { BtnGroup, BtnToolbar } from '@dec/shared';
import { ChatLeft } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { notificationSuccess } from '../../../../core/toast';
import { FormCommunication } from '../components/FormCommunication';
import { createCommunication } from '../http';

import 'app/components/form/combobox/style.scss';

export const CreateCommunication = memo(() => {
  const { t, i18n } = useTranslation();

  const navigate = useNavigate();

  const onSubmit = async ({
    subject,
    content,
    search
  }: {
    subject: string;
    content: string;
    search: { tin: string };
  }) => {
    await createCommunication({ subject, content, tin: search.tin });
    notificationSuccess(t('common.messages.messageSent'));
    navigate('/');
  };

  return (
    <>
      <PageTitle title={t('taxpayer-notification.title.sendMessagePage')} icon={ChatLeft} />
      <FormCommunication form="formCommunication" onSubmit={onSubmit} />

      <br></br>
      <BtnToolbar>
        <BtnGroup>
          <Button
            action={ButtonAction.cancel}
            variant="secondary"
            onClick={() => {
              navigate('/');
            }}
          />
        </BtnGroup>
        <BtnGroup>
          <Button
            form="formCommunication"
            action={ButtonAction.save}
            text={t('taxpayer-notification.title.sendMessagePage')}
            variant="primary"
            type="submit"
          />
        </BtnGroup>
      </BtnToolbar>
    </>
  );
});
